import React from "react";
import { motion } from "framer-motion";
import LearningLanguageImg from "../../../images/Learning language with friend.png";

const IllustrationSection = () => {
  return (
    <div className="w-full h-auto p-8 flex items-center justify-center">
      <div className="relative w-full max-w-2xl">
        {/* Animated Floating Image */}
        <motion.img
          src={LearningLanguageImg}
          alt="Learning language with friend"
          className="w-full max-w-md"
          // initial={{ opacity: 0, y: 20 }} // Starts slightly lower
          animate={{ opacity: 1, y: [20, -10, 20] }} // Moves up and down
          transition={{
            duration: 3,
            repeat: Infinity, // Loops forever
            // repeatType: "reverse", // Smooth back and forth motion
            // ease: "easeInOut", // Smooth transition
          }}
        />
      </div>
    </div>
  );
};

export default IllustrationSection;
